import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRootDispatch, useRootSelector } from '../../../../store/hooks';
import { selectSiteContentEntriesData } from '../../../../store/features/siteContent';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import {
  fetchIGFEntryByYear,
  selectIGFEntriesData,
  selectIGFEntriesStatus,
} from '../../../../store/features/igfEntries';
import EntryCard from './EntryCard';
import LettersFilter from '../../../shared/LettersFilter';
import Spinner from './Spinner';

import styles from './IGFEntryView.module.scss';
import ExternalError from './ExternalError';

export default function IGFEntryView() {
  const dispatch = useRootDispatch();
  const { t } = useTranslation();
  const { title, url } = useRootSelector(selectSiteContentEntriesData);
  const entriesData = useRootSelector(selectIGFEntriesData);
  const entriesStatus = useRootSelector(selectIGFEntriesStatus);

  useEffect(() => {
    if (url) {
      dispatch(fetchIGFEntryByYear({ dataUrl: url }));
    }
  }, [dispatch, url]);

  const [selectedFilterValue, setSelectedFilterValue] = useState('All');

  const filteredEntries = useMemo(() => {
    if (selectedFilterValue === 'All') {
      return entriesData;
    }

    return entriesData.filter((entryItem) => {
      if (selectedFilterValue === '#') {
        return /[\d#]/.test(entryItem.name[0]);
      }

      return entryItem.name[0].toUpperCase() === selectedFilterValue;
    });
  }, [entriesData, selectedFilterValue]);

  const handleLettersFilterChange = (filterValue: string) => {
    setSelectedFilterValue(filterValue);
  };

  const loading = entriesStatus === 'pending';
  const showError = entriesStatus === 'rejected';
  const showContent = entriesStatus === 'fulfilled';

  return (
    // @ts-ignore
    <SiteLayout
      helmet={{
        title: t('event.year'),
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className={styles.entriesTitle}>{title}</div>

            <LettersFilter
              selectedValue={selectedFilterValue}
              onChange={handleLettersFilterChange}
            />

            <div className={styles.entriesWrapper}>
              {loading && (
                <div className="text-center">
                  <Spinner />
                </div>
              )}
              {showError && <ExternalError />}
              {showContent && filteredEntries.length > 0 && (
                <div className="row">
                  {filteredEntries.map((entryItem) => (
                    <div className="col-xs-12 col-md-6" key={entryItem.id}>
                      <EntryCard {...entryItem} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
